import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import validationMessages from 'vee-validate/dist/locale/es'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\.*/i)
    if (matched && matched.length > 1) {
      const locale = matched[1].split('.')[0] // Get the main locale part (e.g., 'es' from 'es' or 'theme.es')
      if (!messages[locale]) {
        messages[locale] = {}
      }
      const translations = locales(key)
      Object.assign(messages[locale], translations)
    }
  })
  return messages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

Vue.use(VeeValidate, {
  VueI18nRootKey: 'validations', // customize the root path for validation messages.
  VueI18n,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  dictionary: {
   es: validationMessages
  },
  fieldsBagName: 'inputs'
})